import ActionHint from '../ActionHint';
import { DOCUMENT_LINK_UNAVAILABLE } from '../constants';
import type { IdvDocument } from '../types';
import { DocChipLink, DocChipPlain, DocChips, DocExt, DocId, DocThumb } from './styled';
import type { DocChipView } from './types';
import { getDocChipView } from './utils';

interface DocumentChipsProps {
  documents: IdvDocument[];
}

const ChipBody = ({
  thumb,
  label,
  idLabel,
  extension,
}: Pick<DocChipView, 'thumb' | 'label' | 'idLabel' | 'extension'>) => (
  <>
    <DocThumb aria-hidden>{thumb}</DocThumb>
    {label} <DocId>{idLabel}</DocId> {extension ? <DocExt>{extension}</DocExt> : null}
  </>
);

const DocumentChips = ({ documents }: DocumentChipsProps) => {
  if (documents.length === 0) return null;

  return (
    <DocChips data-testid="idv-doc-chips">
      {documents.map((document) => {
        const chip = getDocChipView(document);
        const body = (
          <ChipBody thumb={chip.thumb} label={chip.label} idLabel={chip.idLabel} extension={chip.extension} />
        );

        if (chip.href) {
          return (
            <DocChipLink
              key={chip.key}
              href={chip.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="idv-doc-chip"
            >
              {body}
            </DocChipLink>
          );
        }

        return (
          <ActionHint key={chip.key} title={DOCUMENT_LINK_UNAVAILABLE} testId="idv-doc-chip-hint">
            <DocChipPlain data-testid="idv-doc-chip" data-disabled="true">
              {body}
            </DocChipPlain>
          </ActionHint>
        );
      })}
    </DocChips>
  );
};

export default DocumentChips;
